import LocationViewport from './components/LocationViewport';
import Viewport from './components/Viewport';
import Results from './components/Results';
import Question from './components/Question';
import AppCover from './components/AppCover';
import App404 from './components/App404';
import AnswerBlank from './components/AnswerBlank';

/* Utilities */
const __getFirstLocationId = data => {
    const arr = data.quiz.locations;
    return arr && arr.length > 0 ? 0 : '';
};

/* Getting initial setting and data */
const data = require('../../../../../data/basic.json');

const __getLocationData = index => {
    return data.quiz.locations[index];
};

const __getQuestionData = (locationIndex, index) => {
    return __getLocationData(locationIndex).questions[index];
};

module.exports.getLocationData = __getLocationData;
module.exports.getQuestionData = __getQuestionData;

module.exports.routes = [
    {
        path: '',
        name: 'cover',
        component: AppCover,
        props: () => {
            return {
                data: data,
                next: '/location/0/question/0',
                nextLabel: 'From Cover To The First Question'
            };
        }
    },
    {
        path: '/404',
        name: '404',
        component: App404,
        props: () => {
            return {
                data: data
            };
        }
    },
    {
        path: '/results',
        name: 'results',
        component: Results,
        props: () => {
            return {
                data: data,
                restartDestination: `/location/${__getFirstLocationId(data)}/question/0`
            };
        }
    },
    {
        path: '/location/:index',
        component: LocationViewport,
        props: route => {
            const location = data.quiz.locations[parseInt(route.params.index)];
            return {
                title: location.title,
                className: 'location-viewport'
            };
        },
        children: [
            {
                path: 'question/:questionIndex',
                component: Viewport,
                props: () => {
                    return {
                        className: 'question-viewport'
                    };
                },
                children: [
                    {
                        path: '',
                        name: 'question',
                        component: Question,
                        props: route => {
                            const locationIndex = parseInt(route.params.index);
                            const location = __getLocationData(locationIndex);
                            const index = parseInt(route.params.questionIndex);
                            const question = location.questions[index];
                            const next = `../answer/${index}`;
                            const nextLabel = `Location "${location.title}": answer for the question ${index}. `;

                            return {
                                index: index,
                                basicData: data,
                                data: question,
                                next: next,
                                nextLabel: nextLabel
                            };
                        }
                    }
                ]
            },
            {
                path: 'answer/:questionIndex',
                component: Viewport,
                props: () => {
                    return {
                        className: 'answer-viewport'
                    };
                },
                children: [
                    {
                        path: '',
                        name: 'answer',
                        component: AnswerBlank,
                        props: route => {
                            const locationIndex = parseInt(route.params.index);
                            const location = __getLocationData(locationIndex);
                            const index = parseInt(route.params.questionIndex);
                            const question = location.questions[index];
                            let next = `../question/${index + 1}`;
                            let nextLabel = `Location "${location.title}": question ${index + 1}. `;

                            if (index >= location.questions.length - 1) {
                                if (locationIndex >= data.quiz.locations.length - 1) {
                                    next = '/results';
                                    nextLabel += ' (To Results)';
                                } else {
                                    next = `../../${locationIndex + 1}/question/0`;
                                    nextLabel += ` (To the first question of "${data.quiz.locations[locationIndex + 1].title}")`;
                                }
                            }

                            return {
                                data: question,
                                next: next,
                                nextLabel: nextLabel
                            };
                        }
                    }
                ]
            }
        ]
    }
];
